<template>
  <div class="product-matrix utlz-row utlz-reset" ref="productListContainer">
    <div class="utlz-col-md-12">

          <template v-if="!matrixProducts.length && !noProductsFound">
            <h2>Loading products...</h2>
          </template>
          <div class="mtrx-table">
            <div class="mtrx-hdr">
              <div class="mtrx-row">
                <div class="prod-code" v-translation="{ type: 'label', code: 'label_mtrx_prodcode'}"></div>
                <template v-if="screenWidth > 767">                  
                  <div  :class="{ 'double-col': containsLongValue(prodSpecDesc)}" class="prod-spec" v-for="prodSpecDesc in categorySpecifications" :key="prodSpecDesc">
                    {{ prodSpecDesc }}
                  </div>
                </template>
                <div v-if="showStock" class="prod-stock" v-translation="{ type: 'label', code: 'label_mtrx_stock'}"></div>
                <div v-if="showPrices" class="prod-price" v-translation="{ type: 'label', code: 'label_mtrx_price'}"></div>
                <div v-if="showPrices" class="prod-order" v-translation="{ type: 'label', code: 'label_mtrx_order'}"></div>
              </div>
            </div>
            <div class="mtrx-body">
              <utlz-product-matrix-row
                v-for="product in matrixProducts"
                :key="product.id"
                :product="product"
                :blockSize="12"
                class="product-list-item">
              </utlz-product-matrix-row>
            </div>

            <utlz-pagination v-if="totalPages > 1" :totalPages="totalPages" :currentPage="currentPage" :scrollToTop="true" @changePage="changePage($event)"></utlz-pagination>

          </div>

        <div v-if="noProductsFound" class="no-products-found">
          <h2 v-translation="{ type: 'label', code: 'label_no_products_found'}"></h2>
        </div>

      </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ElasticProductMatrixRow from './ElasticProductMatrixRow.vue';
import Pagination from 'src/components/ui/pagination/Pagination.vue';

export default {
  components: {
    'utlz-pagination': Pagination,
    'utlz-product-matrix-row': ElasticProductMatrixRow
  },
  data() {
    return {
      activeProductId: ""
    }
  },
  computed: {
    ...mapState('elastic', ['filters', 'stringProperties', 'layoutType', 'blockSize', 'pageSizes']),
    ...mapGetters('elastic', ['matrixProducts', 'pageTitle', 'totalPages', 'currentPage', 'pageRange', 'totalProducts', 'noProductsFound', 'categorySpecifications']),
    ...mapGetters(['showStock', 'showPrices', 'showOrderProduct', 'screenWidth'])
  },
  methods: {
    ...mapActions('elastic', ['initElastic', 'updateFilters', 'changePage', 'changeLayout', 'changePageSize', 'toggleMobileFilters', 'changePageSorting']),
    navigateToProductPage (href) {
      location.href = href;
      localStorage.setItem('scrollPositionTop', window.pageYOffset);
    },
    containsLongValue(value) {
      var value = value.toLowerCase();
      return value == 'afmeting' || 
      value == 'dimensions' ||
      value == 'abmessungen';
    },
  },
  created () {
    this.initElastic();
  }
};
</script>

<style>
</style>
